import {SxProps} from '@mui/material';

export const STYLES = {
  root: {
    position: 'relative',
    height: '50px',
    width: '100%',
  },
  wrapper: {
    position: 'absolute',
    inset: 0,
    width: '100%',
  },
  tabList: {
    '& .MuiTabs-flexContainer': {
      gap: '20px',
      height: '50px',
    },

    '& .MuiTabs-indicator': {
      display: 'none',
    },

    '& .MuiTabScrollButton-root': {
      height: '43px',

      '& .Mui-disabled': {
        opacity: 0.8,
      },
    },
  },
  tab: {
    position: 'relative',
    height: '43px',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid #EFF0F6',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '6px',
    minHeight: '43px',
    pr: 4,
    pl: 1,

    '&.Mui-selected': {
      border: '1.5px solid #0D99FF',
      color: '#000000',
    },

    '& .MuiTouchRipple-root': {
      display: 'none',
    },
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    width: '176px',
    height: '43px',
    backgroundColor: '#FFFFFF',
    border: '1.5px solid #EFF0F6',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '6px',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '19px',
    color: '#000000',
  },
  navigationButtonWrapper: {
    pb: 0.5,
  },
  navigationButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '5px 10px',
    width: '44px',
    minWidth: '44px',
    height: '30px',
    backgroundColor: 'rgba(38, 50, 56, 0.05)',
    borderRadius: '4px',
    color: '#263238',
  },
  moreButton: {
    position: 'absolute',
    top: '4px',
    right: '2px',
    width: '18px',
    height: '18px',
  },
  tabInput: {
    width: '140px',

    '& .MuiInputBase-input': {
      py: 0.2,
    },
  },
  tabTitle: {
    width: '140px',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '19px',
    color: '#000000',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
} as const satisfies SxProps;
